<template>
  <main-drawer :title="isEdit ? $tc('tournament.edit_club_deduction') : $tc('tournament.add_club_deduction')" @close="$emit('close')">
    <main-select
      v-model="form.clubId"
      :label="$tc('general.club')"
      :options="clubOptions"
      :validator="$v.form.clubId"
    />

    <main-input
      v-model.number="form.deduction"
      :label="$tc('club.cost_reduction')"
      :validator="$v.form.deduction"
      append="%"
    />

    <template v-slot:footer>
      <div class="flex-buttons">
        <el-button @click="$emit('close')">{{ $tc('general.cancel') }}</el-button>
        <el-button type="primary" @click="save()">{{ isEdit ? $tc('general.edit') : $tc('general.save') }}</el-button>
      </div>
    </template>
  </main-drawer>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'
import { required, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
  props: {
    seminar: {
      type: Object,
      required: true
    },
    clubDeduction: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      form: {
        clubId: null,
        deduction: null
      }
    }
  },

  computed: {
    isEdit () {
      return !!this.clubDeduction
    },

    allClubs () {
      const clubs = this.$store.getters['clubs/list'] || []
      return clubs.filter(c => !c.isBlocked && !c.isDeleted)
    },

    existingClubIds () {
      return this.seminar.clubDeductions?.map(d => parseInt(d.clubId)) || []
    },

    clubOptions () {
      return this.allClubs
        .filter(c => !this.existingClubIds.includes(c.id) || (this.isEdit && this.clubDeduction.clubId === c.id))
        .map(c => ({ id: c.id, text: c.name }))
    }
  },

  created () {
    if (this.clubDeduction) {
      this.form = {
        clubId: this.clubDeduction.clubId,
        deduction: this.clubDeduction.deduction
      }
    }
    this.$store.dispatch('clubs/load')
  },

  methods: {
    async save () {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) return

      const payload = {
        clubId: this.form.clubId,
        deduction: this.form.deduction,
        seminarId: this.seminar.id
      }

      this.loading = true
      try {
        let result
        if (this.isEdit) {
          result = await this.$store.dispatch('seminarClubDeductions/update', {
            id: this.clubDeduction.id,
            payload
          })
        } else {
          result = await this.$store.dispatch('seminarClubDeductions/create', payload)
        }
        this.$message.success(this.isEdit ? this.$tc('messages.success_updated_club_deduction') : this.$tc('messages.success_created_club_deduction'))
        this.$emit(this.isEdit ? 'edit' : 'add', result)
      } catch (error) {
        errorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  validations: {
    form: {
      clubId: { required },
      deduction: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(100)
      }
    }
  }
}
</script>
